// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/login_background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login Container with Background Image */
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1b23;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 24px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: relative;
}

/* Gradient overlay — dark theme */
.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(26, 27, 35, 0.9) 0%,
    rgba(34, 35, 43, 0.8) 50%,
    rgba(26, 27, 35, 0.92) 100%
  );
  z-index: 0;
}

.login-container > * {
  position: relative;
  z-index: 1;
}

/* Login Box — dark card style matching dashboard */
.login-box {
  background: rgba(34, 35, 43, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 50px 44px;
  width: 100%;
  max-width: 440px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow:
    0 32px 64px -16px rgba(0, 0, 0, 0.6),
    0 0 0 1px rgba(255, 255, 255, 0.04);
  animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Header */
.login-header {
  text-align: center;
  margin-bottom: 44px;
}

.login-header h1 {
  color: #e2e8f0;
  font-size: 36px;
  margin: 0 0 14px 0;
  font-weight: 700;
  letter-spacing: -1px;
  background: none;
  -webkit-background-clip: unset;
  -webkit-text-fill-color: unset;
  background-clip: unset;
}

.login-header p {
  color: #64748b;
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.2px;
}

/* Form */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Input Group */
.input-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.input-group label {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.input-group input {
  width: 100%;
  padding: 16px 18px;
  font-size: 15px;
  color: #e2e8f0;
  background: #1a1b23;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
  box-shadow: none;
}

.input-group input::placeholder {
  color: #4a4b57;
}

.input-group input:hover {
  border-color: rgba(255, 255, 255, 0.18);
  background: #1e1f27;
}

.input-group input:focus {
  border-color: #2873ff;
  background: #1e1f27;
  box-shadow: 0 0 0 3px rgba(40, 115, 255, 0.15);
}

.input-group input:disabled {
  background: #1a1b23;
  color: #4a4b57;
  cursor: not-allowed;
}

/* Password Wrapper */
.password-wrapper {
  position: relative;
}

.password-wrapper input {
  padding-right: 52px;
}

/* Password Toggle Button */
.password-toggle {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(40, 115, 255, 0.08);
  border: none;
  padding: 10px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 8px;
}

.password-toggle:hover {
  color: #2873ff;
  background: rgba(40, 115, 255, 0.15);
}

.password-toggle:focus {
  outline: none;
}

.password-toggle svg {
  display: block;
}

/* Error Message */
.error-message {
  background: rgba(248, 113, 113, 0.1);
  color: #f87171;
  padding: 16px 20px;
  border-radius: 10px;
  font-size: 14px;
  text-align: center;
  border: 1px solid rgba(248, 113, 113, 0.2);
  animation: shake 0.5s ease;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-6px); }
  40%, 80% { transform: translateX(6px); }
}

/* Login Button — blue accent matching dashboard */
.login-button {
  width: 100%;
  padding: 18px 28px;
  background: #2873ff;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  margin-top: 12px;
  font-family: inherit;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 15px rgba(40, 115, 255, 0.3);
}

.login-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.15),
    transparent
  );
  transition: left 0.5s ease;
}

.login-button:hover:not(:disabled) {
  background: #2060e0;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(40, 115, 255, 0.4);
}

.login-button:hover:not(:disabled)::before {
  left: 100%;
}

.login-button:active:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(40, 115, 255, 0.3);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.login-button span {
  position: relative;
  z-index: 1;
}

/* Button Loading State */
.button-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.button-loading .spinner {
  width: 20px;
  height: 20px;
  border: 2.5px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 480px) {
  .login-container {
    padding: 16px;
  }

  .login-box {
    padding: 40px 28px;
    border-radius: 14px;
  }

  .login-header h1 {
    font-size: 30px;
  }

  .login-header p {
    font-size: 14px;
  }

  .input-group input {
    padding: 14px 16px;
    font-size: 16px; /* Prevents zoom on iOS */
  }

  .login-button {
    padding: 16px 24px;
  }
}

@media (max-width: 360px) {
  .login-box {
    padding: 32px 22px;
  }

  .login-header h1 {
    font-size: 26px;
  }
}

@media (max-height: 600px) {
  .login-container {
    align-items: flex-start;
    padding-top: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yDAAuD;EACvD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,uFAAuF;EACvF,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C;;uCAEqC;EACrC,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe,EAAE,yBAAyB;EAC5C;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF","sourcesContent":["/* Login Container with Background Image */\n.login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1a1b23;\n  background-image: url('../assets/login_background.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 24px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  position: relative;\n}\n\n/* Gradient overlay — dark theme */\n.login-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(26, 27, 35, 0.9) 0%,\n    rgba(34, 35, 43, 0.8) 50%,\n    rgba(26, 27, 35, 0.92) 100%\n  );\n  z-index: 0;\n}\n\n.login-container > * {\n  position: relative;\n  z-index: 1;\n}\n\n/* Login Box — dark card style matching dashboard */\n.login-box {\n  background: rgba(34, 35, 43, 0.85);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 16px;\n  padding: 50px 44px;\n  width: 100%;\n  max-width: 440px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow:\n    0 32px 64px -16px rgba(0, 0, 0, 0.6),\n    0 0 0 1px rgba(255, 255, 255, 0.04);\n  animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Header */\n.login-header {\n  text-align: center;\n  margin-bottom: 44px;\n}\n\n.login-header h1 {\n  color: #e2e8f0;\n  font-size: 36px;\n  margin: 0 0 14px 0;\n  font-weight: 700;\n  letter-spacing: -1px;\n  background: none;\n  -webkit-background-clip: unset;\n  -webkit-text-fill-color: unset;\n  background-clip: unset;\n}\n\n.login-header p {\n  color: #64748b;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n}\n\n/* Form */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Input Group */\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.input-group label {\n  color: #94a3b8;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n.input-group input {\n  width: 100%;\n  padding: 16px 18px;\n  font-size: 15px;\n  color: #e2e8f0;\n  background: #1a1b23;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  outline: none;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  box-shadow: none;\n}\n\n.input-group input::placeholder {\n  color: #4a4b57;\n}\n\n.input-group input:hover {\n  border-color: rgba(255, 255, 255, 0.18);\n  background: #1e1f27;\n}\n\n.input-group input:focus {\n  border-color: #2873ff;\n  background: #1e1f27;\n  box-shadow: 0 0 0 3px rgba(40, 115, 255, 0.15);\n}\n\n.input-group input:disabled {\n  background: #1a1b23;\n  color: #4a4b57;\n  cursor: not-allowed;\n}\n\n/* Password Wrapper */\n.password-wrapper {\n  position: relative;\n}\n\n.password-wrapper input {\n  padding-right: 52px;\n}\n\n/* Password Toggle Button */\n.password-toggle {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(40, 115, 255, 0.08);\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  border-radius: 8px;\n}\n\n.password-toggle:hover {\n  color: #2873ff;\n  background: rgba(40, 115, 255, 0.15);\n}\n\n.password-toggle:focus {\n  outline: none;\n}\n\n.password-toggle svg {\n  display: block;\n}\n\n/* Error Message */\n.error-message {\n  background: rgba(248, 113, 113, 0.1);\n  color: #f87171;\n  padding: 16px 20px;\n  border-radius: 10px;\n  font-size: 14px;\n  text-align: center;\n  border: 1px solid rgba(248, 113, 113, 0.2);\n  animation: shake 0.5s ease;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  20%, 60% { transform: translateX(-6px); }\n  40%, 80% { transform: translateX(6px); }\n}\n\n/* Login Button — blue accent matching dashboard */\n.login-button {\n  width: 100%;\n  padding: 18px 28px;\n  background: #2873ff;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  margin-top: 12px;\n  font-family: inherit;\n  position: relative;\n  overflow: hidden;\n  letter-spacing: 0.3px;\n  box-shadow: 0 4px 15px rgba(40, 115, 255, 0.3);\n}\n\n.login-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.15),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.login-button:hover:not(:disabled) {\n  background: #2060e0;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(40, 115, 255, 0.4);\n}\n\n.login-button:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(40, 115, 255, 0.3);\n}\n\n.login-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.login-button span {\n  position: relative;\n  z-index: 1;\n}\n\n/* Button Loading State */\n.button-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.button-loading .spinner {\n  width: 20px;\n  height: 20px;\n  border: 2.5px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .login-container {\n    padding: 16px;\n  }\n\n  .login-box {\n    padding: 40px 28px;\n    border-radius: 14px;\n  }\n\n  .login-header h1 {\n    font-size: 30px;\n  }\n\n  .login-header p {\n    font-size: 14px;\n  }\n\n  .input-group input {\n    padding: 14px 16px;\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n\n  .login-button {\n    padding: 16px 24px;\n  }\n}\n\n@media (max-width: 360px) {\n  .login-box {\n    padding: 32px 22px;\n  }\n\n  .login-header h1 {\n    font-size: 26px;\n  }\n}\n\n@media (max-height: 600px) {\n  .login-container {\n    align-items: flex-start;\n    padding-top: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
